import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import {
	Close,
	Drawer,
	DrawerClose,
	DrawerContent,
	DrawerDescription,
	DrawerFooter,
	DrawerHeader,
	DrawerTitle,
	ScrollArea,
	UserData,
} from '@/app/shared/components';
import { MenuItem } from './components';

interface DashboardMenuProps {
	isOpen: boolean;
	onClose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DashboardMenu: React.FC<DashboardMenuProps> = ({
	isOpen,
	onClose,
}: DashboardMenuProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/
	return (
		<Drawer open={isOpen} onOpenChange={onClose} direction="right">
			<DrawerContent className="h-full rounded-t-none bg-gradient-to-br from-slate-700 via-customer-700 to-customer-900">
				<div className="mx-auto w-full max-w-sm ">
					<DrawerHeader>
						<DrawerTitle>
							<VisuallyHidden>Dashboard Menu</VisuallyHidden>
							<DrawerClose className="right-5 text-right absolute">
								<Close fillcolor="#fff" />
							</DrawerClose>
						</DrawerTitle>
					</DrawerHeader>
					<DrawerDescription>
						<VisuallyHidden>Dashboard Menu</VisuallyHidden>
					</DrawerDescription>
					<div className="mx-auto">
						<UserData />

						<ScrollArea className="h-[calc(100dvh-200px)] w-full">
							<ul className="flex flex-col m-6">
								{/* commented collection */}
								{/* <MenuItem
									path="/collections"
									name={
										t('dashboardNav.collections') ||
										'Collections'
									}
									icon={process.env.VITE_COLLECTIONS_ICON}
									isEnabled={
										process.env.VITE_ENABLE_COLLECTIONS
											? true
											: false
									}
									isComingSoon={false}
								/> */}
								{/* commented wallet */}
								{/* <MenuItem
									path="/wallet"
									name={t('dashboardNav.wallet') || 'Wallet'}
									icon={process.env.VITE_WALLET_ICON}
									isEnabled={
										process.env.VITE_ENABLE_WALLET
											? true
											: false
									}
									isComingSoon={false}
								/> */}

								<MenuItem
									path="/shop"
									name={t('dashboardNav.shop') || 'Shop'}
									icon={process.env.VITE_SHOP_ICON}
									isEnabled={
										process.env.VITE_ENABLE_SHOP
											? true
											: false
									}
									isComingSoon={false}
								/>

								<MenuItem
									path="/skins"
									name={'Skins'}
									icon={process.env.VITE_SKIN_ICON}
									isEnabled={
										process.env.VITE_ENABLE_SKINS
											? true
											: false
									}
									isComingSoon={false}
								/>

								{/*  */}

								<MenuItem
									path="/settings"
									name={
										t('dashboardNav.settings') || 'Settings'
									}
									icon={process.env.VITE_SETTINGS_ICON}
									isEnabled={true}
									isComingSoon={false}
								/>

								{/* <MenuItem
									path="/roulette"
									name={
										t('dashboardNav.roulette') || 'Roulette'
									}
									icon={process.env.VITE_ROULETTE_ICON}
									isEnabled={
										process.env.VITE_ENABLE_ROULETTE
											? true
											: false
									}
									isComingSoon={true}
								/>

								<MenuItem
									path="/battle-pass"
									name={
										t('dashboardNav.battlePass') ||
										'Battle Pass'
									}
									icon={process.env.VITE_BATTLE_PASS_ICON}
									isEnabled={
										process.env.VITE_ENABLE_BATTLEPASS
											? true
											: false
									}
									isComingSoon={true}
								/> */}
							</ul>
						</ScrollArea>
					</div>
					<DrawerFooter>
						<DrawerClose asChild></DrawerClose>
					</DrawerFooter>
				</div>
			</DrawerContent>
		</Drawer>
	);
};
